import Card from 'components/card/Card'

function Approvals() {
  return (
    <div className="content-wrapper">
      <Card>
        <Card.Header className="w-full pb-0" border={false}></Card.Header>
        <Card.Body>
          <div className="w-full">
            <div className="flex flex-col items-center py-20">
              <img src="/media/socialSearch.svg" />
              <h4 className="text-xl mt-5 text-[#858C95]">Belum Ada Purchase Order</h4>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default Approvals
